import FileSaver from 'file-saver'

function formatWeightColumn(record) {
  let result
  if (record.settings_change !== 0) {
    result = ''
  } else if (record.estimated_weight === null) {
    result = Number(record.weight * 2.204622).toFixed(1)
  } else {
    result = Number(record.estimated_weight * 2.204622).toFixed(1)
  }
  return result
}

function formatCompliance(record) {
  let result
  if (record.settings_change !== 0) {
    result = ''
  } else {
    switch (record.check_in_type) {
      case 1:
        result = 'No'
        break

      case 2:
        result = 'Yes'
        break

      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        result = 'Forced'
        break

      case 4:
        result = 'Start'
        break

      case 10:
      case 11:
        result = 'Reset'
        break

      default:
        result = ''
    }
  }
  return '"' + result + '"'
}


function formatGoalName(goal) {
  let result

  if (goal === 'FAT LOSS') {
    result = 'Fat Loss'
  } else if (goal === 'MUSCLE GAIN') {
    result = 'Muscle Gain'
  } else if (goal === 'REVERSE DIETING') {
    result = 'Reverse Dieting'
  } else if (goal === 'MAINTENANCE') {
    result = 'Maintenance'
  } else {
    result = ''
  }
  return '"' + result + '"'
}

function exportTimeline(timeline, ascendingOrder) {
  let data = '"Date","Weight(lbs)","BF%","In range","Protein","Carbs","Fat","kCal","Goal","Type"\n'
  for (let n = 0; n < timeline.length; ++n) {
    const record = timeline[ascendingOrder ? (timeline.length - 1 - n) : n]
    const dateText = record.report_date.slice(0, 10)
    const weightText = formatWeightColumn(record)
    const bodyFatText = record.body_fat ? (record.body_fat * 0.01).toFixed(3) : ''
    const complianceText = formatCompliance(record)
    const proteinText = record.macros ? Math.round(record.macros.protein) : ''
    const carbsText = record.macros ? Math.round(record.macros.carbs) : ''
    const fatText = record.macros ? Math.round(record.macros.fat) : ''
    const kcalText = record.macros ? (4 * (Math.round(record.macros.protein) + Math.round(record.macros.carbs)) + 9 * Math.round(record.macros.fat)) : ''
    const goalText = formatGoalName(record.goal)
    const typeText = record.settings_change ? 'Settings change' : 'Check-in'
    const newRow = dateText + ',' + weightText + ',' + bodyFatText + ',' + complianceText + ',' + proteinText + ',' + carbsText + ',' + fatText + ',' + kcalText + ',' + goalText + ',' + typeText + '\n'
    if (record.macros && record.settings_change === 0) {
      if (ascendingOrder) {
        data += newRow
      }
      for (let m = 0; m < record.daily_weights.length; ++m) {
        const dw = record.daily_weights[ascendingOrder ? (record.daily_weights.length - 1 - m) : m];
        const dwDateText = dw.weigh_in_date.slice(0, 10)
        const dwWeightText = Number(dw.weight * 2.204622).toFixed(1)
        data += dwDateText + ',' + dwWeightText + ',,,,,,,,Daily weight\n'
      }
      if (!ascendingOrder) {
        data += newRow
      }
    } else {
      data += newRow
    }
  }
  const blob = new Blob([data], {type: 'text/csv;charset=utf-8'})
  FileSaver.saveAs(blob, 'timeline.csv')
}

export { exportTimeline }